import UserModel, { IUserModel } from "../models/DTO/UserModel";
import { IUserLoginModel } from "../models/DTO/UserLoginModel";
import ApiResponseModel from "../models/API/ApiResponseModel";
import * as reqAxios from "./HttpService";
import ApiEndpoints, { IUserControllerEndpoint } from "../configurations/ApiEndpoints";
import { CreateAuthHeader, CreateCancellableConfig } from "../configurations/DefaultAxiosConfig";
import ErrorModel, { IErrorModel } from "../models/DTO/ErrorModel";
import defaultAxios from "../configurations/DefaultAxiosConfig";
import { CancelToken } from "axios";
import UserViewModel, { IUserViewModel } from "../viewModels/UserViewModel";
import { DencryptText, EncryptText } from "../Helpers/CryptoHelper";

const ApiPath = (): IUserControllerEndpoint => {
    const baseEndoint: IUserControllerEndpoint | undefined = new ApiEndpoints().User;

    if (!baseEndoint)
        throw new Error("User endpoint could not be null.");

    return baseEndoint;
}

/** Not used yet, maybe remove in future */
export const GetAll = (token: string, callback: (users: IUserModel[], messages?: string[], error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "") {

        const config = CreateAuthHeader("Bearer", token, cancelToken);

        reqAxios.Get(`${ApiPath().GetAll}`, config, (response, error) => {
            const { Data: data, Messages, Error } = reqAxios.HandleResponse(response, error),
                userItens: IUserModel[] = (data != null && data.map((item: any) => new UserModel().LoadFromAPI(item))) || [];

            callback && callback(userItens, Messages, Error);
        });
    }
}

export const GetUsersProposal = (token: string, callback: (users: IUserModel[], messages?: string[], error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "") {

        const config = CreateAuthHeader("Bearer", token, cancelToken);

        reqAxios.Get(`${ApiPath().GetUsersProposal}`, config, (response, error) => {
            const { Data: data, Messages, Error } = reqAxios.HandleResponse(response, error),
                userItens: IUserModel[] = (data != null && data.map((item: any) => new UserModel().LoadFromAPI(item))) || [];

            callback && callback(userItens, Messages, Error);
        });
    }
}

export const GetUsers = (token: string, callback: (users: IUserModel[], messages?: string[], error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "") {
        const config = CreateAuthHeader("Bearer", token, cancelToken);

        reqAxios.Get(`${ApiPath().GetUsers}`, config, (response, error) => {
            const { Data: data, Messages, Error } = reqAxios.HandleResponse(response, error),
                userItens: IUserModel[] = (data != null && data.map((item: any) => new UserModel().LoadFromAPI(item))) || [];

            callback && callback(userItens, Messages, Error);
        });
    }
}

export const GetUsersStream = (token: string, callback: (users: IUserModel[], messages?: string[], error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "") {
        const config = CreateAuthHeader("Bearer", token, cancelToken);
        reqAxios.GetStream(`${ApiPath().GetUsersStream}`, config,
            (response, error) => {
                const users: IUserModel[] = (response?.data != null && response?.data != "" && response.data.map((item: any) => new UserModel().LoadFromAPI(item))) || [];
                callback && callback(users, [], error);
            });
    }
}

export const UserLoginByCompany = (userLogin: IUserLoginModel, callback: (user?: IUserModel, error?: IErrorModel) => void, cancelToken?: CancelToken): void => {

    const formData = new FormData(),
        boddy = userLogin.ToJson();

    formData.append("serializedDto", EncryptText(process.env.REACT_APP_USER_KEY!, boddy));

    const config = CreateCancellableConfig(cancelToken, formData);

    reqAxios.Post(`${ApiPath().UserLoginByCompany}`, undefined, config, (response, error) => {
        const { Data: data, Error } = reqAxios.HandleResponse(response, error),
            decrypted = (data != null && data != "" && new UserModel().LoadFromApiByCompany(JSON.parse(DencryptText(data, process.env.REACT_APP_USER_KEY!)))) || undefined,
            userModel: IUserModel | undefined = (decrypted != null && decrypted) || undefined;

        callback && callback(userModel, Error);
    });
}

/** Not used yet, maybe remove in future */
export const UserLoginByCompanyAsync = async (userLogin: IUserLoginModel): Promise<{ user?: IUserModel, error?: IErrorModel }> => {
    if (userLogin == null)
        throw new Error("userlogin could not be null.");

    try {
        const url: string = `${ApiPath().UserLoginByCompany}`,
            formData = new FormData(),
            boddy = JSON.stringify(userLogin.ToJson());

        formData.append("serializedDto", EncryptText(process.env.REACT_APP_USER_KEY!, boddy));

        const apiResponse = await defaultAxios.post(url, formData, undefined),
            api: ApiResponseModel = new ApiResponseModel(apiResponse),
            data = api && api.Data,
            userModel: IUserModel | undefined = (data != null && new UserModel().LoadFromApiByCompany(data)) || undefined,
            result = { user: userModel, error: undefined };

        return result;
    }
    catch (err: any) {
        const { request, response } = err,
            model = {
                userCompanyPermissions: [], error: new ErrorModel(response?.data, (request == null || request.status == 0) ? 500 : request.status)
            }

        return model;
    }
}

/** Not used yet, maybe remove in future */
export const GetUserById = (token: string, id: number, callback: (user?: IUserModel, error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "" && id > 0) {

        const config = CreateAuthHeader("Bearer", token, cancelToken);

        reqAxios.Get(`${ApiPath().GetUserById}?userId=${id}`, config, (response, error) => {
            const { Data: data, Error } = reqAxios.HandleResponse(response, error),
                user: IUserModel | undefined = (data != null && data as IUserModel) || undefined;

            callback && callback(user, Error);
        });
    }
}

/** Not used yet, maybe remove in future */
export const GetUserPermissions = (token: string, id: number, callback: (userInfo?: IUserViewModel, messages?: string[], error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "" && id > 0) {

        const config = CreateAuthHeader("Bearer", token, cancelToken);

        reqAxios.Get(`${ApiPath().GetUserPermissions}?userId=${id}`, config, (response, error) => {
            const { Data: data, Messages, Error } = reqAxios.HandleResponse(response, error),
                decrypted = JSON.parse(DencryptText(data, process.env.REACT_APP_USER_KEY!)),
                userInfo: IUserViewModel | undefined = (decrypted != null && new UserViewModel().LoadFromAPI(decrypted)) || undefined;

            callback && callback(userInfo, Messages, Error);
        });
    }
}

export const GetUsersByCompany = (token: string, callback: (users: IUserModel[], messages?: string[], error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "") {
        const config = CreateAuthHeader("Bearer", token, cancelToken);

        reqAxios.Get(`${ApiPath().GetUsersByCompany}`, config, (response, error) => {
            const { Data: data, Messages, Error } = reqAxios.HandleResponse(response, error),
                userItens: IUserModel[] = (data != null && data.map((item: any) => new UserModel().LoadFromAPI(item))) || [];

            callback && callback(userItens, Messages, Error);
        });
    }
}

export const Create = (token: string, user: IUserModel, callback?: (isSuccess: boolean, userId: number, message?: string[], error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "") {

        if (!user)
            throw new Error("User could not be null.");

        const config = CreateAuthHeader("Bearer", token, cancelToken);
        reqAxios.Post(`${ApiPath().Create}`, user.ToJson(), config, (response, error) => {
            const { IsSuccess, Messages, Error, Data } = reqAxios.HandleResponse(response, error);

            callback && callback(IsSuccess, Data, Messages, Error);
        });
    }
}

export const Update = (token: string, user: IUserModel, callback: (isSuccess: boolean, message?: string[], error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "") {

        if (!user)
            throw new Error("User could not be null.");

        const config = CreateAuthHeader("Bearer", token, cancelToken);

        reqAxios.Put(`${ApiPath().Update}?userId=${user.Id}`, user.ToJson(), config, (response, error) => {
            const { IsSuccess, Messages, Error } = reqAxios.HandleResponse(response, error);

            callback && callback(IsSuccess, Messages, Error);
        });
    }
}

export const Delete = (token: string, id: number, callback: (isSuccess: boolean, message?: string[], error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "") {

        if (!id || id == 0)
            throw Error("Id to delete an user colut not be null or less then 1.");

        const config = CreateAuthHeader("Bearer", token, cancelToken);

        reqAxios.Delete(`${ApiPath().Delete}?userId=${id}`, config, (response, error) => {
            const { IsSuccess, Messages, Error } = reqAxios.HandleResponse(response, error);

            callback && callback(IsSuccess, Messages, Error);
        });
    }
}